/*
 * @Author: your name
 * @Date: 2021-12-02 21:15:18
 * @LastEditTime: 2022-02-21 11:24:34
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /fore-trade-birthday-h5/src/pages/newPayBill/components/PayPassword/keyboard/index.tsx
 */
import React from 'react';
// import './index.scss'
import styles from './index.less';
import delImg from '../imgs/del.png';

const Keyboard = (props) => {
  const { callback } = props;
  const inputNum = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '', '0', 'x'];

  return (
    <ul className={styles.pwdKeyBoard}>
      {
        inputNum.map((item) => (
          <li
            key={`pwdKeyBoard${item}`}
            className={`${styles[item === '' || item === 'x' ? 'noBg' : '']}`}
            onTouchStart={() => callback(item)}
          >
            <span className={styles.pwdKeyBoardContent}>
              {item === 'x' ? <img src={delImg} /> : item}
            </span>
          </li>
        ))
      }
    </ul>
  );
};

export default Keyboard;
